import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '@constants/common/environmentLinkEndpointNames';
import { HEADER_LINKS_TYPES, STATE_EXCLUDES, EXCLUDE_PATHS, EXTRA_ACTIONS } from '../constants/headerLinkTypes';
import { configs } from '@constants/configs/configs';
import { ssapModalTypes as MODAL_TYPES } from '@constants/ssap/modals/ssapModalTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { onLogout } from '@utils/localStorage/sessionStorageUtils';

const {
    routes
} = configs;

export const minnesotaHeaderLogo = {
    link: true,
    tagline: false
};
export const minnesota_fs = {
    linkDetails: [
        {
            name: 'language',
            className: ['usa-nav__primary-item gi-main__nav__primary-item link__language'],
            linkClassName:['gi-main__nav__primary-item__link'],
            text: 'header.lang',
            path: '#',
            type: HEADER_LINKS_TYPES.LANGUAGE_SWITCH,
            visible: environment => environment.anonymous || environment.impersonation || environment.user && environment.user.role === ALL_USER_ROLES.INDIVIDUAL,
        },
        {
            name: 'login',
            text: 'header.login',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGIN,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment) => environment.anonymous
        },
        {
            name: 'home',
            text: 'header.home',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            symbols: ['home'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => {
                const currentState = environment.stateCode;
                const excludePaths = STATE_EXCLUDES[currentState] || EXCLUDE_PATHS;
                return !excludePaths.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus;
            }
        },
        {
            name: 'secured-mail',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['lock', 'envelope'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.UNREAD_MESSAGES,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => {
                const currentState = environment.stateCode;
                const excludePaths = STATE_EXCLUDES[currentState] || EXCLUDE_PATHS;
                return !telexEnabled && !excludePaths.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus;
            },
            showUnreadMessage: true
        },
        {
            name: 'secured-mail-telex',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName: ['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['lock', 'envelope'],
            path: routes.NEW_INBOX_HOME,
            type: HEADER_LINKS_TYPES.ICON_REACT_ROUTER,
            visible: (environment, currentPath, telexEnabled, errorStatus) => {
                const currentState = environment.stateCode;
                const excludePaths = STATE_EXCLUDES[currentState] || EXCLUDE_PATHS;
                return telexEnabled &&!excludePaths.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus;
            },
            showUnreadMessage: true
        },
        {
            name: 'get-assistance',
            text: 'header.getAssistance',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--01'],
            ariaClassName: ['extended-nav-section-one'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.isState.MN,
            dropdown: [
                {
                    name: 'find-assistance',
                    className: ['usa-nav__submenu-item'],
                    text: 'header.getAssistance.localAssistance',
                    path: '#',
                    type: HEADER_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL
                },
                {
                    name: 'contact',
                    text: 'header.getAssistance.contactUs',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.CONTACT_US,
                    type: HEADER_LINKS_TYPES.LINK,
                    additionalProperties: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                },
                {
                    name: 'contact-phone',
                    text: 'header.getAssistance.contactUs_number',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.PHONE,
                    symbol: 'phone',
                    tooltip: {
                        text: 'header.getAssistance.contactUs_number.tooltip',
                        placement: 'left',
                    },
                    tooltipClassName: 'gi-tooltip',
                    linkClassName:'',
                    triggerDecorationClassName: 'border-none',
                    type: HEADER_LINKS_TYPES.TOOLTIP
                }
            ]
        },
        {
            name: 'my-authentication',
            text: 'header.myAccount',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--02'],
            ariaClassName: ['extended-nav-section-two'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.isMNFullStack,
            visible: (environment, currentPath, telexEnabled, errorStatus) => {
                const currentState = environment.stateCode;
                const excludePaths = STATE_EXCLUDES[currentState] || EXCLUDE_PATHS;
                return !excludePaths.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus;
            },
            dropdown: [
                {
                    name: 'authentication-settings',
                    text: 'header.myAccount.accountSettings',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.SETTINGS,
                    type: HEADER_LINKS_TYPES.LINK,
                    visible: environment => environment.user
                },
                {
                    name: 'dashboard',
                    text: 'header.myAccount.dashboard',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
                    type: HEADER_LINKS_TYPES.LINK
                },
                {
                    name: 'logout',
                    text: 'header.myAccount.logout',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGOUT,
                    type: HEADER_LINKS_TYPES.LINK,
                    extraAction: EXTRA_ACTIONS.CHECK_SSAP,
                    beforeClick: onLogout
                }
            ]
        }
    ]
};